import api from "@/api";

const state = {
  status: "",
  list: []
};

const getters = {
  isLoading: (state) => state.status === "loading",
  // getMessage: state => state.list.reverse(),
  isLikePerUser: (state, getters, rootState) => (message_id) => {
    const message = state.list.filter(
      (message) => message.Id === message_id
    )[0];
    const likes = message.Likes.map((like) => like.CreatedById);
    return likes.includes(rootState.user.user.UserID);
  },
  getMessageId: (state) => (message_id) =>
    state.list.filter((message) => message.Id === message_id)[0]
};

const actions = {
  all: ({ dispatch, commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/MessageApi/all", {
          params: {
            CompanySelected: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resp.data.forEach((message) => {
            dispatch(
              "comment/get",
              {
                object_t: "Messages",
                object_id: message.Id
              },
              { root: true }
            );
          });
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  get: ({ commit, rootState }, { message_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get(`/api/MessageApi/get/${message_id}`, {
          params: {
            id: message_id,
            CompanySelected: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  update: ({ commit }, { update_message }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .put(`/api/MessageApi/Update`, update_message, {
          params: {
            id: update_message.Id
          }
        })
        .then((resp) => {
          commit("success");
          commit("updateItem", {
            message_id: update_message.Id,
            message: resp.data
          });
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  create: ({ commit }, { new_message }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .post("/api/MessageApi/Add", new_message)
        .then((resp) => {
          commit("success");
          commit("pushItem", resp.data);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  delete: ({ commit }, { message_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .delete(`/api/MessageApi/delete`, {
          params: {
            id: message_id
          }
        })
        .then((resp) => {
          commit("success");
          commit("removeItem", message_id);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  add_like: ({ commit, rootState }, { message_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/MessageApi/AddLike", {
          params: {
            id: message_id,
            userId: rootState.user.user.UserID
          }
        })
        .then((resp) => {
          commit("success");
          commit("pushLikeItem", {
            message_id: message_id,
            like: resp.data
          });
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  remove_like: ({ commit, rootState }, { message_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const user_id = rootState.user.user.UserID;
      api
        .get("/api/MessageApi/RemoveLike", {
          params: {
            id: message_id,
            userId: user_id
          }
        })
        .then((resp) => {
          commit("success");
          commit("removeLikeItem", {
            message_id: message_id,
            user_id: user_id
          });
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  updateItem: (state, payload) => {
    const index = state.list.findIndex((l) => l.Id === payload.message_id);
    state.list.splice(index, 1, payload.message);
  },
  pushItem: (state, item) => {
    state.list.unshift(item);
  },
  pushLikeItem: (state, payload) => {
    const message = state.list.filter(
      (message) => message.Id === payload.message_id
    )[0];

    message.Likes.push(payload.like);
    message.CountLike++;
  },
  removeItem: (state, message_id) => {
    const index = state.list.findIndex((l) => l.Id === message_id);
    state.list.splice(index, 1);
  },
  removeLikeItem: (state, payload) => {
    const message = state.list.filter((m) => m.Id === payload.message_id)[0];
    const index = message.Likes.findIndex(
      (like) => like.CreatedById === payload.user_id
    );

    message.Likes.splice(index, 1);
    message.CountLike = message.CountLike > 0 ? message.CountLike - 1 : 0;
  },
  pushCommentItem: (state, payload) => {
    const message = state.list.filter(
      (message) => message.Id === payload.message_id
    )[0];

    message.Comments.push(payload.comment);
    message.CountComment++;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
